<template>
  <div>
    <LKProgressCircular
      v-if="isLoadingAsyncData"
      overlay
      :size="50"
      style="align-items: start; padding-top: 30vh;"
    />

    <MainForm
      v-else
      :mun-meh="single"
      :form-id="formId"
      :slug="slug"
      :topic-slug="topicSlug"
      :levels="levels"
      :view-type="viewType"
    />
  </div>
</template>

<script>
import LKMunMehFormView from '@/views/LKMunMeh/Form/LKMunMehFormView.vue'
import { BASE_DELIMITER_URL } from '@/views/LKMunMeh/utils'
import { toNumber } from 'lodash'
import { LKMunMehReviewMapper as StoreMapper } from '@/views/LKMunMeh/Review/store'

const MainForm = () => import(
  /* webpackChunkName: "LKMunMehMainForm" */
  '@/views/LKMunMeh/Review/components/LKMunMehReviewForm.vue'
)

export default {
  name: 'LKMunMehFormView',
  components: {
    MainForm,
  },
  extends: LKMunMehFormView,
  data: () => ({
    formId: null,
  }),
  created() {
    this.resetState()
  },
  methods: {
    ...StoreMapper.mapMutations(['resetState']),
    onConfigurationChanged(route) {
      const { params } = route
      if (params) {
        if (params.levels) {
          this.levels = params.levels.replace(/\/$/, '').split(BASE_DELIMITER_URL).map((el) => toNumber(el))
        } else {
          this.levels = []
        }

        this.formId = toNumber(params.formId)
      }
    },
  },
}
</script>

